import {
  bindSingleAssetAgentView,
  createSingleAssetAgentConversation,
  getSingleAssetAgentConversation,
  getSingleAssetBindingView,
} from "../../api/client";

// 打开一只持仓的核算页。概览和添加关注页（/screener）共用同一条路——
// 直接跳 `/single?holding=<id>` 是空白页：核算页需要先有会话和绑定，再带着绑定视图过去。
// 抛出的错误由调用方展示。
export async function openHoldingPage(navigate, item, { agentHandoff = null, returnTo = null } = {}) {
  if (!item.holding_id) throw new Error("该持仓尚未完成稳定标识迁移，请刷新后重试");
  const knownConversationId = agentHandoff?.turnResult?.conversation_id
    || window.sessionStorage.getItem("single_asset_agent_active_conversation");
  const latest = knownConversationId
    ? await getSingleAssetAgentConversation(knownConversationId, { historyLimit: 200 })
    : await createSingleAssetAgentConversation();
  const binding = await bindSingleAssetAgentView(
    latest.conversation_id,
    latest.revision,
    { type: "holding", target_id: item.holding_id, asset_code: item.asset_code },
  );
  const bindingView = await getSingleAssetBindingView(
    latest.conversation_id,
    binding.binding_id,
  );
  const nextTurnResult = {
    ...latest,
    revision: binding.conversation_revision,
    current_binding_id: binding.binding_id,
  };
  navigate(`/single?conversation=${encodeURIComponent(latest.conversation_id)}&binding=${encodeURIComponent(binding.binding_id)}&holding=${encodeURIComponent(item.holding_id)}`, {
    state: {
      singleAssetAgentHandoff: {
        turnResult: nextTurnResult,
        messages: agentHandoff?.messages ?? [],
      },
      singleAssetBindingView: bindingView,
      returnTo,  // 从哪个页面进来的（如 /screener）；核算页「返回」据此回到那里
    },
  });
}
